module.exports = __webpack_public_path__ + "static/desktop/img/words-right.22ef9d49.jpg";